import { Head } from '@inertiajs/react'
import Button from '../../Components/Button'
import Layout from '../GuestOrder/Layout'

export default function Invalid() {
  return (
    <>
      <Head title="Review link expired" />
      <Layout account={null}>
        <div className="min-h-screen px-4 py-16 max-w-md mx-auto text-white text-center">
          <div className="text-5xl mb-6" aria-hidden="true">⛳</div>
          <h1 className="text-2xl font-bold mb-4">This review link isn&apos;t valid</h1>
          <p className="text-white/70 mb-8">
            The link may have expired, or it wasn&apos;t copied correctly. Review links
            work for 30 days after your order.
          </p>
          <Button href="/clubs" variant="secondary" theme="dark" size="lg" className="rounded-xl">
            Find Your Club
          </Button>
        </div>
      </Layout>
    </>
  )
}
